import { ConsumptionSetProps } from '@api/models/consumption-set';
import { filterUnique } from './array';
import { Values } from './objectEnums';
import { PortRotationEntryGeneratorTypes } from './port-rotation-entry-generator-types';

/*
* Gets a default consumption set id by filtering
* the port rotation by unique consumption profile ids.
* If the length of unique consumption set ids is 1, then all ids match
*/
export const getDefaultConsumptionSetId = (
	portRotation: {
		consumptionSetId: number | null;
		generatedBy: Values<typeof PortRotationEntryGeneratorTypes> | null;
	}[],
	consumptionSets: ConsumptionSetProps[] | undefined,
) => {
	if (!consumptionSets) {
		return undefined;
	}

	let defaultConsumptionSetId: number | undefined = consumptionSets?.[0]?.id;

	if (consumptionSets && consumptionSets.length > 1) {
		const uniqueConsumptionSetIds = filterUnique(
			portRotation.filter(
				(p) => p.consumptionSetId != null &&
				!(p.generatedBy === PortRotationEntryGeneratorTypes.CANAL_TRANSIT),
			),
			(p) => p.consumptionSetId!.toString(),
		);

		if (uniqueConsumptionSetIds.length === 1) {
			defaultConsumptionSetId = portRotation[0].consumptionSetId ?? undefined;
		}
	}

	return defaultConsumptionSetId;
};
